export var MapType;
(function (MapType) {
    /** ROADMAP - Roadmap map type */
    MapType["ROADMAP"] = "ROADMAP";
    /** SATELLITE - Satellite map type */
    MapType["SATELLITE"] = "SATELLITE";
    /** HYBRID - Hybrid map type */
    MapType["HYBRID"] = "HYBRID";
    /** TERRAIN - Terrain map type */
    MapType["TERRAIN"] = "TERRAIN";
    MapType["UNRECOGNIZED"] = "UNRECOGNIZED";
})(MapType || (MapType = {}));
//# sourceMappingURL=plugin_map.enums.js.map